import { CommonMutationCrumbs } from './breadcrumb';

export const SearchPersonCohabitationCrumbs = [
  ...CommonMutationCrumbs,
  {
    name: 'Ricerca persona - Dichiarazione Convivenza',
    path: '/mutazioni/persona/convivenza',
  },
];

export const BewareCrumbs = [
  ...CommonMutationCrumbs,
  {
    name: 'Gestione Diffide',
    path: '/mutazioni/diffida/registrazione',
  },
];

export const AnomalyCrumbs = [
  ...CommonMutationCrumbs,
  {
    name: 'Gestione Anomalie',
    path: '/mutazioni/anomalia/registrazione',
  },
];

export const ResolutionSearchCrumbs = [
  ...CommonMutationCrumbs,
  {
    name: 'Ricerca persona - Risoluzione Convivenza',
    path: '/mutazioni/persona/risoluzione-convivenza',
  },
];

export const DeclarationCohabitationCrumbs = [
  ...SearchPersonCohabitationCrumbs,
  {
    name: 'Dichiarazione convivenza',
    path: '/mutazioni/persona/convivenza/dichiarazione',
  },
];

export const ResolutionCohabitationCrumbs = [
  ...ResolutionSearchCrumbs,
  {
    name: 'Risoluzione Convivenza',
    path: '/mutazioni/persona/risoluzione-convivenza/dichiarazione',
  },
];
